module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_7.8ba27561.png";